import { EAssessmentDecision } from '@modules/literatures/types';

// A document with no product has nothing to assess against.
const resolveLiteratureDecision = (
  hasProduct: boolean,
  whenHasProduct: EAssessmentDecision | null
): EAssessmentDecision | null => (hasProduct ? whenHasProduct : EAssessmentDecision.NOT_REQUIRED);

export default resolveLiteratureDecision;
